import React, { useState } from 'react';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import {
  TableInput,
  TextAreaInput,
} from '../../../../../../../../components/common';
import CustomSelect from '../../../../../../../../components/common/SelectField';
import { MenuItem } from '@mui/material';

interface IProps {
  moduleData: any;
  isView: boolean;
}

const TBody = ({ moduleData, isView }: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <tbody>
      {moduleData &&
        moduleData?.c1?.map((process: any, index: number) => (
          <tr>
            <td>{index + 1}</td>
            <td style={{ minWidth: '300px', textAlign: 'center' }}>
              {process.loot_at}
            </td>
            <td style={{ minWidth: '300px', textAlign: 'center' }}>
              {process.look_for}
            </td>
            <td colSpan={3} style={{ minWidth: '300px', textAlign: 'center' }}>
              <TextAreaInput
                isView={isView}
                name="obs1"
                value={process.obs1}
                onChange={(e) => {
                  handleChangeModuleData(e, process);
                  setRender((prev) => !prev);
                }}
              />
            </td>
            <td style={{ minWidth: '100px', textAlign: 'center' }}>
              {isView ? (
                process.status
              ) : (
                <CustomSelect
                  name="status"
                  value={process.status}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                >
                  <MenuItem value="">NONE</MenuItem>
                  <MenuItem value="OK">OK</MenuItem>
                  <MenuItem value="NOT OK">NOT OK</MenuItem>
                </CustomSelect>
              )}
            </td>
          </tr>
        ))}
    </tbody>
  );
};

export default TBody;
